import React from 'react';

const FeedbackMessage = ({ type = 'info', children }) => {
  if (!children) {
    return null;
  }

  return <div className={`feedback-message feedback-message--${type}`}>{children}</div>;
};

export default FeedbackMessage;
